import request from '@/utils/request'

export function list(params) {
  return request({
    url: '/questions',
    method: 'get',
    params,
  })
}
